// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dp-addin {
  font-family: var(--dp-font-family);
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: var(--dp-color-background);
}

.dp-addin__header {
  display: flex;
  align-items: center;
  gap: var(--dp-spacing-sm);
  padding: var(--dp-spacing-sm) var(--dp-spacing-md);
  color: var(--dp-color-primary);
  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);
  background: var(--dp-color-surface);
}

.dp-addin__title {
  font-size: var(--dp-font-size-md);
  font-weight: var(--dp-font-weight-bold);
  flex: 1;
}

/* New button + dropdown */
.dp-addin__new-wrap {
  position: relative;
}

.dp-addin__new-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border: 1px solid var(--dp-color-primary);
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  background: var(--dp-color-primary);
  color: var(--dp-color-text-inverse);
  transition: all 0.12s;
  white-space: nowrap;
}
.dp-addin__new-btn:hover { background: var(--dp-color-primary-hover); border-color: var(--dp-color-primary-hover); }
.dp-addin__new-btn--active {
  background: var(--dp-color-primary-hover);
}

.dp-addin__new-caret {
  font-size: 9px;
  opacity: 0.8;
}

.dp-addin__new-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  background: var(--dp-color-background);
  border: 1px solid var(--dp-color-border);
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.12);
  min-width: 170px;
  z-index: 100;
  overflow: hidden;
}

.dp-addin__new-option {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  background: none;
  border: none;
  text-align: left;
  font-size: 12px;
  color: var(--dp-color-text);
  cursor: pointer;
  transition: background 0.1s;
}
.dp-addin__new-option:hover { background: var(--dp-color-surface); }
.dp-addin__new-option + .dp-addin__new-option {
  border-top: 1px solid var(--dp-color-border);
}

.dp-addin__new-option-icon {
  font-size: 14px;
  color: var(--dp-color-primary);
  width: 16px;
  text-align: center;
  flex-shrink: 0;
}

/* Back button */
.dp-addin__back-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  padding: 2px 6px;
  color: var(--dp-color-primary);
  border-radius: var(--dp-border-radius-sm);
}
.dp-addin__back-btn:hover {
  background: var(--dp-color-surface-hover);
}

/* Quick action bar */
.dp-addin__quick-actions {
  display: flex;
  gap: 4px;
  padding: 4px var(--dp-spacing-md);
  border-bottom: 1px solid var(--dp-color-border);
  background: var(--dp-color-surface);
}
.dp-addin__quick-btn {
  flex: 1;
  padding: 5px 4px;
  font-size: 11px;
  background: var(--dp-color-background);
  border: 1px solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  cursor: pointer;
  text-align: center;
  transition: all 0.12s;
}
.dp-addin__quick-btn:hover {
  background: var(--dp-color-primary);
  color: var(--dp-color-text-inverse);
  border-color: var(--dp-color-primary);
}

/* Content area */
.dp-addin__content {
  flex: 1;
  overflow-y: auto;
  padding: var(--dp-spacing-md);
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/App.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kDAAkD;EAClD,8BAA8B;EAC9B,uEAAuE;EACvE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,OAAO;AACT;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,mCAAmC;EACnC,qBAAqB;EACrB,mBAAmB;AACrB;AACA,2BAA2B,yCAAyC,EAAE,2CAA2C,EAAE;AACnH;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,sCAAsC;EACtC,wCAAwC;EACxC,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,2BAA2B;AAC7B;AACA,8BAA8B,mCAAmC,EAAE;AACnE;EACE,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,QAAQ;EACR,iCAAiC;EACjC,+CAA+C;EAC/C,mCAAmC;AACrC;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,wCAAwC;EACxC,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA,iBAAiB;AACjB;EACE,OAAO;EACP,gBAAgB;EAChB,6BAA6B;AAC/B","sourcesContent":[".dp-addin {\n  font-family: var(--dp-font-family);\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  background: var(--dp-color-background);\n}\n\n.dp-addin__header {\n  display: flex;\n  align-items: center;\n  gap: var(--dp-spacing-sm);\n  padding: var(--dp-spacing-sm) var(--dp-spacing-md);\n  color: var(--dp-color-primary);\n  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);\n  background: var(--dp-color-surface);\n}\n\n.dp-addin__title {\n  font-size: var(--dp-font-size-md);\n  font-weight: var(--dp-font-weight-bold);\n  flex: 1;\n}\n\n/* New button + dropdown */\n.dp-addin__new-wrap {\n  position: relative;\n}\n\n.dp-addin__new-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border: 1px solid var(--dp-color-primary);\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  background: var(--dp-color-primary);\n  color: var(--dp-color-text-inverse);\n  transition: all 0.12s;\n  white-space: nowrap;\n}\n.dp-addin__new-btn:hover { background: var(--dp-color-primary-hover); border-color: var(--dp-color-primary-hover); }\n.dp-addin__new-btn--active {\n  background: var(--dp-color-primary-hover);\n}\n\n.dp-addin__new-caret {\n  font-size: 9px;\n  opacity: 0.8;\n}\n\n.dp-addin__new-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  background: var(--dp-color-background);\n  border: 1px solid var(--dp-color-border);\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.12);\n  min-width: 170px;\n  z-index: 100;\n  overflow: hidden;\n}\n\n.dp-addin__new-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 8px 12px;\n  background: none;\n  border: none;\n  text-align: left;\n  font-size: 12px;\n  color: var(--dp-color-text);\n  cursor: pointer;\n  transition: background 0.1s;\n}\n.dp-addin__new-option:hover { background: var(--dp-color-surface); }\n.dp-addin__new-option + .dp-addin__new-option {\n  border-top: 1px solid var(--dp-color-border);\n}\n\n.dp-addin__new-option-icon {\n  font-size: 14px;\n  color: var(--dp-color-primary);\n  width: 16px;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n/* Back button */\n.dp-addin__back-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  padding: 2px 6px;\n  color: var(--dp-color-primary);\n  border-radius: var(--dp-border-radius-sm);\n}\n.dp-addin__back-btn:hover {\n  background: var(--dp-color-surface-hover);\n}\n\n/* Quick action bar */\n.dp-addin__quick-actions {\n  display: flex;\n  gap: 4px;\n  padding: 4px var(--dp-spacing-md);\n  border-bottom: 1px solid var(--dp-color-border);\n  background: var(--dp-color-surface);\n}\n.dp-addin__quick-btn {\n  flex: 1;\n  padding: 5px 4px;\n  font-size: 11px;\n  background: var(--dp-color-background);\n  border: 1px solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  cursor: pointer;\n  text-align: center;\n  transition: all 0.12s;\n}\n.dp-addin__quick-btn:hover {\n  background: var(--dp-color-primary);\n  color: var(--dp-color-text-inverse);\n  border-color: var(--dp-color-primary);\n}\n\n/* Content area */\n.dp-addin__content {\n  flex: 1;\n  overflow-y: auto;\n  padding: var(--dp-spacing-md);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
